import http from "../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CH_CONSOLE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

const Endpoints = {
  GET_WEBHOOK_LIBRARY_LIST: "/workspace/get-webhooks",
  CREATE_WEBHOOK: "/workspace/create-webhook",
  RUN_TEST_WEBHOOK: "/workspace/test-webhook",
  CONTACT_PROPERTIES: "/workspace/contact-properties/fields?status=visible",
  GET_WEBHOOK_DETAILS: "/workspace/get-webhook",
  EDIT_WEBHOOK: "/workspace/update-webhook",
  DELETE_WEBHOOK: "/workspace/delete-webhook",
};

export class webhookLibraryNetworkService  {
  //get application property options
  static getWebhookList(data: any) {
    console.log("==> getWebhookList",data)
    return http.post(
      `${consoleBaseUrl}${Endpoints.GET_WEBHOOK_LIBRARY_LIST}`,
      data
    );
  }

  static CreateWebhook(data: any) {
    console.log("==> CreateWebhook",data)
    return http.post(`${consoleBaseUrl}${Endpoints.CREATE_WEBHOOK}`, data);
  }

  static RunTestWebhook(data: any) {
    return http.post(`${consoleBaseUrl}${Endpoints.RUN_TEST_WEBHOOK}`, data);
  }

  static getContactProperties() {
    return http.get(`${consoleBaseUrl}${Endpoints.CONTACT_PROPERTIES}`);
  }

  static GetWebhookDetails(id: string) {
    return http.get(`${consoleBaseUrl}${Endpoints.GET_WEBHOOK_DETAILS}/${id}`);
  }
  static EditWebhook(id: string,data : any) {
    return http.put(`${consoleBaseUrl}${Endpoints.EDIT_WEBHOOK}/${id}`,data);
  }
  static DeleteWebhook(id: string) {
    return http.delete(`${consoleBaseUrl}${Endpoints.DELETE_WEBHOOK}/${id}`);
  }
  
}
